import { analyticsService } from 'utils/services/analytics'

import { FilterSource } from './constants'
import { FilterDataType } from './filterConstants'
import { Filter } from './interfaces'

const getFilterAnalyticsData = (filter: Filter | FilterDataType, source: FilterSource) => {
  const filterData = filter.groups?.flatMap((group) =>
    group.items.map((item) => ({
      field: item.field,
      type: item.type,
      operator: item.operator,
    })),
  )

  return {
    source,
    filter: filterData,
  }
}

export const handleFilterAnalyticsData = (
  filter: Filter | FilterDataType | null,
  source: FilterSource,
) => {
  if (!filter) {
    return
  }

  const analyticsData = getFilterAnalyticsData(filter, source)
  analyticsService.sendEvent('FILTER.APPLIED', analyticsData)
}
